import Vue from 'vue';

const moment = require('moment')
require('moment/locale/tr')
Vue.use(require('vue-moment'), {
    moment
});


Vue.filter("toUpperCase", function (v) {
    return v.toUpperCase();
});

Vue.filter("toYas", function (str) {
    var birth = moment(str)
    let months = moment().diff(birth, "months", true);
    let birthSpan = {
        year: Math.floor(months / 12),
        month: Math.floor(months) % 12,
        day: Math.round((months % 1) * birth.daysInMonth(), 0)
    };
    if (birthSpan.year < 1 && birthSpan.month < 1) {
        return birthSpan.day + " GÜN";
    } else if (birthSpan.year < 1) {
        return birthSpan.month + " AY " + birthSpan.day + " GÜN";
    } else if (birthSpan.year < 19) {
        return birthSpan.year + " YIL " + birthSpan.month + " AY";
    } else {
        return birthSpan.year + " YAŞ";
    }
});

Vue.filter("formatUnix", function (value) {
    if (value) {
        var yatis = moment.unix(value)
        let hours = moment().diff(yatis, "seconds", true);
        return Math.ceil(-hours)
    }
}
);

Vue.filter("toGun", function (str) {
    if (str != "") {
        var yatis = moment(str)
        let days = moment().diff(yatis, "days", true);
        return Math.ceil(days) + ".GÜN"
    }
});

Vue.filter("toOnlyGun", function (str) {
    if (str != "") {
        var yatis = moment(str)
        let days = moment().diff(yatis, "days", true);
        return Math.ceil(days)
    }
});

Vue.filter("toYDGun", function (str) {
    if (str != "") {
        var yatis = moment(str)
        let days = moment().diff(yatis, "days", true);
        if (days < 5) {
            let hours = moment().diff(yatis, "hours", true);
            return Math.ceil(hours) + ".SAATİ"
        } else {
            return Math.ceil(days + 1) + ".GÜNÜ"
        }
    }
});

Vue.filter("toSex", function (str) {
    var r
    switch (str) {
        case "1":
            r = "ERKEK"
            break;

        case "2":
            r = "KIZ"
            break;
    }
    return r
});

Vue.filter("toYDSolunum", function (str) {
    var r
    switch (str) {
        case "1":
            r = "K.İÇİ ODA HAVASINDA TAKİPLİ"
            break;
        case "2":
            r = "K.İÇİ SERBEST O2 ALIYOR"
            break;
        case "3":
            r = "K.İÇİ NCPAP'TA TAKİPLİ"
            break;
        case "4":
            r = "K.İÇİ ENTÜBE TAKİPLİ"
            break;
    }
    return r
});

Vue.filter("toBirthStatus", function (str) {
    var r
    switch (str) {
        case "0":
            r = "Anne Yanına Verildi"
            break;

        case "1":
            r = "Yatışı Yapıldı"
            break;

        case "2":
            r = "Sevk Edildi"
            break;

        case "3":
            r = "EX"
            break;
    }
    return r
});